import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=09ff2d5d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=09ff2d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff2d5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ff2d5d')) {
      api.createRecord('09ff2d5d', component.options)
    } else {
      api.reload('09ff2d5d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=09ff2d5d&scoped=true&", function () {
      api.rerender('09ff2d5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W1a4VvzX4oh2/JS/comp/SearchFilterTokens.vue"
export default component.exports